
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";
import { ToolbarVisibilityToggleProps } from "./types";

export const ToolbarVisibilityToggle = ({
  isToolbarVisible,
  setIsToolbarVisible,
  showPricing,
}: ToolbarVisibilityToggleProps) => {
  if (showPricing) return null;

  return (
    <button
      onClick={() => setIsToolbarVisible(!isToolbarVisible)}
      className={cn(
        "mt-1.5 mx-auto px-2 py-1 text-[10px] font-medium", 
        "text-gray-600 bg-white/90 rounded-full transition-all duration-300",
        "hover:bg-gray-50 hover:shadow-md flex items-center gap-1",
        "border border-white/70 shadow-sm backdrop-blur-xl",
        "transform hover:scale-105 active:scale-95",
        "hover:text-blue-600"
      )}
    >
      {isToolbarVisible ? (
        <>
          <EyeOff className="h-2.5 w-2.5" />
          <span>Hide</span>
        </>
      ) : (
        <>
          <Eye className="h-2.5 w-2.5" />
          <span>Show</span>
        </>
      )}
    </button>
  );
};
